import { Button, Flex, Form, Input } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useChangePassword } from '../../../api/hooks/useUserQuery';
import { useNotificationContext } from '../../../contexts/NotificationContext';
import { SignInStageEnum } from '../../../enums/SignInStage';
import { getServerErrorMsg } from '../../../helpers/errorHandler';
import { UserChangePasswordRequest } from '../../../types/user';
import { customizeRequiredMark, validationRules } from '../../../helpers/formHelper';
import { useOTPContext } from '../../../contexts/OtpContext';

interface ActivateUserProps {
  onChangeStage: Function;
}

const ChangePassword = ({ onChangeStage }: ActivateUserProps) => {
  const changePasswordMutation = useChangePassword();
  const { t } = useTranslation('signIn');
  const { successNotification, errorNotification } = useNotificationContext();
  const [form] = useForm();
  const [isRedirectionInProgress, setIsRedirectionInProgress] = useState(false);
  const { getEmail } = useOTPContext();

  const onSubmitChangePassword = () => {
    const changePasswordReq: UserChangePasswordRequest = {
      currentPassword: form.getFieldValue('currentPassword'),
      email: getEmail(),
      newPassword: form.getFieldValue('newPassword'),
      versionId: 0,
    };

    changePasswordMutation.mutate(changePasswordReq, {
      onSuccess: () => {
        setIsRedirectionInProgress(true);
        successNotification(t('passwordChanged'));
        onChangeStage(SignInStageEnum.SIGN_IN);
      },
      onError(response) {
        let errorMsg = getServerErrorMsg(response);
        errorNotification(errorMsg);
      },
    });
  };

  const userPasswordResetForm = () => (
    <Form
      form={form}
      name="sign-in"
      onFinish={onSubmitChangePassword}
      //   onFinishFailed={onFinishFailed}
      autoComplete="off"
      layout="vertical"
      className="w-full max-w-96"
      validateTrigger={false}
      requiredMark={customizeRequiredMark}
      initialValues={{ email: getEmail() }}
    >
      <Form.Item label={t('email')} name="email" className="mb-4">
        <Input disabled={true} />
      </Form.Item>
      <Form.Item
        label={t('currentPassword')}
        name="currentPassword"
        rules={[{ required: true }]}
        className="mb-4"
      >
        <Input.Password
          onChange={() => {
            form.validateFields(['currentPassword']);
          }}
        />
      </Form.Item>
      <Form.Item
        label={t('newPassword')}
        name="newPassword"
        rules={[{ required: true, validator: validationRules(t).PASSWORD }]}
        className="mb-8"
      >
        <Input.Password
          onChange={() => {
            form.validateFields(['newPassword']);
          }}
        />
      </Form.Item>

      <Form.Item>
        <Button
          className="btn-primary mt-6"
          type="primary"
          htmlType="submit"
          block
          loading={changePasswordMutation.isPending || isRedirectionInProgress}
        >
          {t('changePassword')}
        </Button>
      </Form.Item>
      {/* <Form.Item>{t('registerNow')}</Form.Item> */}
    </Form>
  );

  return (
    <Flex className="w-full" justify="center" align="center" vertical gap={8}>
      <p className="mb-4 mt-4 text-base font-medium">{t('changePassword')}</p>
      {userPasswordResetForm()}
    </Flex>
  );
};

export default ChangePassword;
